import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';
import { useAuthStore } from '@/store';

// On startup: if Zustand thinks we're logged in but the token is gone
// (e.g. expired + refresh failed previously), clear the stale auth state.
const { isAuthenticated, logout } = useAuthStore.getState();
if (isAuthenticated && !localStorage.getItem('accessToken')) {
  logout();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
